<ziro-select [fieldId]="'type'"></ziro-select>

@if (phoneButtonsService.isSpeedDialButton(entity)) {
  <ziro-phone-buttons-speed-dial
    #form
    [entity]="entity"
    [parentSubmit$]="parentSubmit$()"
    (ziroFormsUpdate$)="handleButtonChange($event)"
  ></ziro-phone-buttons-speed-dial>
}
@if (phoneButtonsService.isBlfButton(entity)) {
  <ziro-phone-buttons-blf
    #form
    [entity]="entity"
    [parentSubmit$]="parentSubmit$()"
    (ziroFormsUpdate$)="handleButtonChange($event)"
  ></ziro-phone-buttons-blf>
}
@if (phoneButtonsService.isServiceUrlButton(entity) && userMode() === DragDropMode.HELPDESK) {
  <ziro-phone-buttons-service-url-helpdesk
    #form
    [entity]="entity"
    [parentSubmit$]="parentSubmit$()"
    (ziroFormsUpdate$)="handleButtonChange($event)"
    [phone]="phone()"
  ></ziro-phone-buttons-service-url-helpdesk>
}
@if (phoneButtonsService.isIntercomButton(entity) && userMode() === DragDropMode.HELPDESK) {
  <ziro-phone-buttons-intercom
    #form
    [entity]="entity"
    [parentSubmit$]="parentSubmit$()"
    (ziroFormsUpdate$)="handleButtonChange($event)"
  ></ziro-phone-buttons-intercom>
}
@if (phoneButtonsService.isLineButton(entity)) {
  @if (userMode() === DragDropMode.HELPDESK) {
    <ziro-phone-buttons-line-helpdesk
      #form
      [lineFeature]="$any(entity).lineFeature"
      [dnRef]="$any(entity).dn"
      [parentSubmit$]="parentSubmit$()"
      [fieldConfig]="lineFieldConfig()"
      [phone]="phone()"
      [siteId]="siteId()"
      [lineButtonSummary]="lineButtonSummary()"
      [buttonIndex]="buttonIndex()"
      [global360View]="global360View()"
      (lineButtonWasUpdated)="handleButtonChange($event)"
      (lineButtonSummaryWasUpdated)="handleVoicemailChange($event)"
      (dnUpdated)="handleDnChange($event, $any(entity).dn)"
    ></ziro-phone-buttons-line-helpdesk>
  }
  @if (userMode() === DragDropMode.SELF_SERVE) {
    <ziro-phone-buttons-line
      #form
      [entity]="entity"
      [parentSubmit$]="parentSubmit$()"
      (ziroFormsUpdate$)="handleButtonChange($event)"
    ></ziro-phone-buttons-line>
  }
}
